// Slug Generator Tool — turn any text into a clean URL slug.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const slugGeneratorTool: Tool = {
  id: "slug-generator",
  name: () => m.sg_tool_name(),
  description: () => m.sg_tool_description(),
  icon: "🔗",
  basePath: "/slug-generator",
  status: "stable",
  tags: ["slug", "url", "seo", "developer"],
  pages: [
    {
      name: () => m.sg_nav_main(),
      path: "/slug-generator",
      description: () => m.sg_nav_main_desc(),
      icon: "🔗",
    },
  ],
};
